module.exports = __webpack_public_path__ + "static/media/TimeIcon.ec3acee0.svg";